module.exports = require("@nestjs/bullmq");